module.exports = __webpack_public_path__ + "img/anaMarques.c279a417.jpeg";